import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Loader2, UserPlus, CheckCircle2 } from "lucide-react";

export default function AdminTeam() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ email: "", name: "", password: "", role: "team_member" });
  const [creating, setCreating] = useState(false);
  const [created, setCreated] = useState(false);
  const [error, setError] = useState("");

  async function load() {
    const r = await http.get("/admin/team-members");
    setItems(r.data);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function handleCreate(e) {
    e.preventDefault();
    setError(""); setCreating(true);
    try {
      await http.post("/admin/team-members", form);
      setCreated(true);
      setForm({ email: "", name: "", password: "", role: "team_member" });
      await load();
      setTimeout(() => setCreated(false), 3000);
    } catch (err) {
      setError(err?.response?.data?.detail || "Failed to create team member");
    } finally { setCreating(false); }
  }

  return (
    <div data-testid="admin-team">
      <h1 className="text-4xl">Team Members</h1>
      <p className="mt-2 text-navy/65">Admin-only. Create staff accounts (email/password login).</p>

      <form onSubmit={handleCreate} className="card p-7 mt-8 space-y-4" data-testid="team-create-form">
        <h3 className="text-2xl">Invite a new team member</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          <input type="text" required placeholder="Full name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="input-field" data-testid="team-create-name" />
          <input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="input-field" data-testid="team-create-email" />
          <input type="password" required minLength={8} placeholder="Temporary password (min 8)" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="input-field" data-testid="team-create-password" />
          <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})} className="input-field" data-testid="team-create-role">
            <option value="team_member">Team Member</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        {error && <p className="text-sm text-red-500" data-testid="team-create-error">{error}</p>}
        {created && <p className="text-sm text-teal flex items-center gap-2" data-testid="team-create-success"><CheckCircle2 className="w-4 h-4" /> Team member created.</p>}
        <button type="submit" disabled={creating} className="btn-primary" data-testid="team-create-submit">
          {creating ? <Loader2 className="w-4 h-4 animate-spin" /> : <><UserPlus className="w-4 h-4" /> Create Team Member</>}
        </button>
      </form>

      <div className="mt-8">
        <h3 className="text-2xl mb-4">Current team</h3>
        {loading ? <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div> :
        <ul className="card divide-y divide-navy/5">
          {items.map((u) => (
            <li key={u.user_id} className="p-4 flex items-center justify-between text-sm" data-testid={`team-member-${u.user_id}`}>
              <div>
                <div className="text-navy font-medium">{u.name}</div>
                <div className="text-xs text-navy/55">{u.email}</div>
              </div>
              <span className="text-xs uppercase tracking-widest text-gold">{u.role}</span>
            </li>
          ))}
        </ul>}
      </div>
    </div>
  );
}
